import StandardCardCarousel from "./StandardCardCarousel";
import ImageCardCarousel from "./ImageCardCarousel";
import FeaturedCardCarousel from "./FeaturedCardCarousel";

const CardCarouselContainer = ({ dataset }) => {
	const data = window[`cardCarouselContainer_${dataset.guid}`];
	const cardType = data.cards[0].type;
	if (cardType === "featured") {
		return <FeaturedCardCarousel data={data} />;
	} else if (cardType === "image-card") {
		return <ImageCardCarousel data={data} />;
	} else {
		return <StandardCardCarousel data={data} />;
	}
};

export default CardCarouselContainer;
